import { request } from "../axios";

export const stats = {
  get_stats: (params) => {
    return request.get(`/users/statusList`, params);
  },
};
